// Ad Analyzer configuration
// Agent ID for the ad script analyzer (Gemini-based with vision capabilities)
export const AD_ANALYZER_AGENT_ID = '1769630536650047000-513506'

// Prompt template for analyzing ads (copy + visuals)
// The {content} placeholder will be replaced with the actual ad script
export const AD_ANALYZER_PROMPT = `You are an expert marketing analyst specializing in social media advertising. You analyze both ad copy AND visual creative (images/videos) to provide comprehensive insights.

## Your Task

Analyze the following ad and provide your analysis in these sections:

### 1. 📝 Copy Analysis
Evaluate the ad text for:
- Clarity and readability
- Persuasive elements and calls-to-action
- Emotional hooks and storytelling
- Value proposition clarity

Provide: **5 Good Features** and **5 Areas to Improve** for the copy.

### 2. 🖼️ Visual Creative Analysis
**IMPORTANT: You MUST describe and analyze the image/video attached.**

Evaluate:
- **What you see:** Describe the visual (colors, subjects, composition, text overlays)
- **Attention-grabbing elements:** Does it stop the scroll?
- **Product/service showcase:** How well is the offering displayed?
- **Brand feel:** Professional quality, consistency, emotional impact
- **Platform fit:** Is it optimized for social media (aspect ratio, mobile-friendly)?

Provide: **5 Good Features** and **5 Areas to Improve** for the visual.

### 3. 🔗 Copy + Visual Synergy
- Does the visual support the copy's message?
- Is there consistency between text and imagery?
- Overall ad cohesion score (1-10)

### 4. 💡 Recommendations
Provide specific, actionable improvements for both copy AND visual creative.

---

**Ad Copy to analyze:**

{content}

---

Format your response in clean MARKDOWN with clear section headers. Be specific about what you observe in the image/video.`

/**
 * Format the prompt with the ad content
 */
export function formatAdAnalyzerPrompt(adContent: string): string {
  return AD_ANALYZER_PROMPT.replace('{content}', adContent)
}
